<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Reports</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-table"></i>
                    <span>Reports </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container" style="height:92%">
    <div class="component-content col-lg-4">
        <div class="panel panel-info" style="height: 90%">
            <div class="panel-heading">
                <h5 style="display:inline-block">
                    User Reports
                </h5>
                <div class="btn-toolbar pull-right">
                    <div class="btn-group btn-group-md">
                        <a href="{{userReportUrl}}" class="btn btn-info" title="Download Report">
                            <i data-toggle="tooltip" class="fa fa-download fa-lg"></i>
                        </a>
                        <button type="button" class="btn btn-info" title="Show Help" popover="Select Permissions from the list to filter the report down to users with the selected permissions, or leave blank for all users.  To clear your current selection, please hold [CTRL] and click on the selected values." popoverTitle="User Report Help" placement="left" triggers="focus" container="body">
                            <i data-toggle="tooltip" class="fa fa-question fa-lg"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div class="input-group">
                    <label class="input-group-addon">Permission</label>
                    <select name="selectedPermissions" class="form-control" multiple="multiple" [(ngModel)]="selectedPermissionIds" (change)="prepUserUrl()">
                        <option *ngFor="let permission of permissions" [value]="permission.Id">{{ permission.Name }}</option>
                    </select>
                </div>
                <div>

                </div>
            </div>
        </div>
    </div>
    <div class="component-content col-lg-4">
        <div class="panel panel-info" style="height: 90%">
            <div class="panel-heading">
                <h5 style="display: inline-block">
                    Equipment Reports
                </h5>
                <div class="btn-toolbar pull-right">
                    <div class="btn-group btn-group-md">
                        <a href="{{equipmentReportUlr}}" class="btn btn-info" title="Download Report">
                            <i data-toggle="tooltip" class="fa fa-download fa-lg"></i>
                        </a>
                        <button type="button" class="btn btn-info" title="Show Help" popover="Select Companies from the list to filter the report down to equipment owned/operated at minesites under those companies.  After selecting one or more companies, you may filter down to available minesites as well.  If nothing is selected, you will generate a report for all equipment.  To clear your current selection, please hold [CTRL] and click on the selected values." popoverTitle="Equipment Report Help" placement="left" triggers="focus" container="body">
                            <i data-toggle="tooltip" class="fa fa-question fa-lg"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div class="input-group">
                    <label class="input-group-addon">Company</label>
                    <select name="selectedCompanies" class="form-control" multiple="multiple" [(ngModel)]="selectedCompanies" (change)="updateMinesites()">
                        <option *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                    </select>
                </div>
                <div class="input-group">
                    <label class="input-group-addon">Mine Site</label>
                    <select name="selectedMinesites" class="form-control" multiple="multiple" [(ngModel)]="selectedMinesites" (change)="prepEquipmentUrl()">
                        <option *ngFor="let minesite of minesites.Data" [value]="minesite.Id">{{ minesite.Name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="component-content col-lg-4">
        <div class="panel panel-info" style="height: 90%">
            <div class="panel-heading">
                <h5 style="display: inline-block">
                    Associated Manuals Reports
                </h5>
                <div class="btn-toolbar pull-right">
                    <div class="btn-group btn-group-md">
                        <button *ngIf="selectedModelId == 0" disabled="disabled" class="btn btn-info" title="Download Report">
                            <i data-toggle="tooltip" class="fa fa-download fa-lg"></i>
                        </button>
                        <a *ngIf="selectedModelId != 0" href="{{manualsReportUlr}}" class="btn btn-info" title="Download Report">
                            <i data-toggle="tooltip" class="fa fa-download fa-lg"></i>
                        </a>
                        <button type="button" class="btn btn-info" title="Show Help" popover="Select a model to fitler manuals to that model.  Once a model is selected, additional filters will appear, allowing you to filter further.  To clear your current selection, please hold [CTRL] and click on the selected values." popoverTitle="Associated Manuals Report Help" placement="left" triggers="focus" container="body">
                            <i data-toggle="tooltip" class="fa fa-question fa-lg"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div class="input-group">
                    <label class="input-group-addon">Model</label>
                    <select name="selectedModel" class="form-control" [(ngModel)]="selectedModelId" (change)="updateModel()">
                        <option *ngFor="let model of models.Data" [value]="model.Id">{{ model.Name }}</option>
                    </select>
                </div>
                <div class="input-group" *ngIf="selectedModelId > 0">
                    <label class="input-group-addon">Powered By</label>
                    <select name="selectedMinesites" class="form-control" multiple="multiple" [(ngModel)]="selectedPoweredByIds" (change)="updatePoweredBys()">
                        <option *ngFor="let poweredBy of poweredBys" [value]="poweredBy.Id">{{ poweredBy.Name }}</option>
                    </select>
                </div>
                <div class="input-group" *ngIf="selectedPoweredByIds.length > 0">
                    <label class="input-group-addon">Serial Number</label>
                    <select name="selectedEquipmentIds" class="form-control" multiple="multiple" [(ngModel)]="selectedEquipmentIds" (change)="updateEquipmentIds()">
                        <option *ngFor="let equipment of equipment.Data" [value]="equipment.Id">{{ equipment.Serial }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>
